export const classifyQuests = (quests, healthStatuses = {}, selectedQuestId = null) => {

  // attach campaignStatus on each quest
  const enriched = quests.map(q => ({
    ...q,
    campaignStatus: healthStatuses[q._id] || null
  }));

  console.log('enriched', enriched);
  /** ------------------------
   * SPLIT GROUPS
   * ------------------------*/
  const active = enriched
    .filter(q =>
      q.isWebsiteBoard ||
      (q.isShared && !q.draft) ||
      (q.active && q.questionnaires?.[0]?.answer === "services") ||
      (!q.active && q.matchingSubId?.status === "past_due")
    )
    .sort((a, b) => {
      const order = { ACTIVE: 1, PAUSED: 2 };
      return (order[a.campaignStatus] || 3) - (order[b.campaignStatus] || 3);
    });

  const archived = enriched.filter(q =>
    !q.isWebsiteBoard &&
    !q.isShared &&
    !q.draft &&
    !q.active &&
    q.matchingSubId?.status !== "past_due"
  );

  const drafts = enriched.filter(q => q.draft);

  /** ------------------------
   * Decide which list to return
   * ------------------------*/
  if (selectedQuestId) {
    // if (active.some(q => q._id === selectedQuestId)) return active;
    // if (archived.some(q => q._id === selectedQuestId)) return archived;
    // if (drafts.some(q => q._id === selectedQuestId)) return drafts;
  }


  console.log('archived', archived);
  
  // Default
  return {active, archived};
};





const SYSTEM_KEYMAP = {
  Name: "Name",
  FullName: "Full Name",
  Tel: "Tel",
  Phone: "Tel",
  Email: "Email",
  City: "City",
  Surname: "Surname",
};


export const buildSchemaFromLanding = (landing) => {
  const systemFields = (landing?.defaultFormFields || []).map((k) => {
    const mapped = SYSTEM_KEYMAP[k] || k;
  

      return {
      id: `sys_${k}`,
      key: k,                         // ✅ FullName
      label: SYSTEM_KEYMAP[k] || k,   // ✅ Full Name
      type: "input",
      isCustom: false,
    };
  });

  const customFields = (landing?.customFormField || []).map((f, i) => ({
    id: `cus_${i}`,
    key: f.label,      // IMPORTANT: matches lead.CustomField[].key
    label: f.label,
    type: f.type || "input",
    isCustom: true,
    required: f.required === true || f.required === 'true'
      || f.isRequired === true || f.isRequired === 'true',
  }));

  return [...systemFields, ...customFields];
};
